exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-bg-blur{z-index:-2;opacity:0;position:absolute;min-height:100%;display:block;top:0;max-height:none;left:-20%;top:-20%;width:140%;height:140%;-webkit-transition:opacity .8s linear;transition:opacity .8s linear}.vux-bg-blur-overlay{z-index:-1;position:absolute;width:100%;height:100%;background:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.15)),to(#000));background:linear-gradient(180deg,rgba(0,0,0,.15),#000)}", ""]);

// exports
